import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { VisualAssetEditorByIdWrapper } from '@/components/VisualAssetEditor/VisualAssetEditorByIdWrapper';
import { useToast } from '@/hooks/use-toast';

export const AssetEditor: React.FC = () => {
  const { assetId } = useParams<{ assetId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();

  const collectionId = searchParams.get('collectionId');
  const editorMode = searchParams.get('editorMode') as 'crop' | 'annotation' | 'mask' | null;


  const handleSave = async (data: any) => {
    console.log('Asset saved:', data);
    toast({
      title: "Asset Updated",
      description: "Asset saved successfully.",
    });

    // Navigate back to collection if we have a collectionId
    if (collectionId) {
      navigate(`/collections/${collectionId}`);
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  const handleCancel = () => {
    // Navigate back to collection if we have a collectionId
    if (collectionId) {
      navigate(`/collections/${collectionId}`);
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  if (!assetId) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Asset Not Found</h1>
          <p className="text-gray-600 mb-4">No asset ID provided</p>
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-screen">
      <VisualAssetEditorByIdWrapper
        assetId={assetId}
        onSave={handleSave}
        onCancel={handleCancel}
        showSaveControls={true}
        className="w-full h-full"
      />
    </div>
  );
};